"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AdBannerModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdBannerModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const backoffice_1 = require("../../dsl/backoffice");
const form_1 = require("../_abstract/form");
const _contracts_1 = require("../_contracts");
const AdBanner_contracts_1 = require("./AdBanner.contracts");
/**
 * Component that contains a complete questionnaire needed to **EDIT** the `AdBanner`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 * @author Olga Milczek <olga.mikczek@movecloser.pl>
 */
let AdBannerModuleForm = AdBannerModuleForm_1 = class AdBannerModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        this.DashmixIconName = backoffice_1.DashmixIconName;
        /**
         * TODO: Description.
         */
        this.isDescribing = true;
        /**
         * @inheritDoc
         * @override
         */
        this.initialContent = AdBannerModuleForm_1.getInitialContent();
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.AdBanner,
            version: AdBanner_contracts_1.AdBannerVersion.GoogleAds,
            size: {
                colSpan: 6,
                isResizable: true,
                maxColSpan: 6,
                maxRowSpan: 6,
                minColSpan: 2,
                minRowSpan: 2,
                rowSpan: 2
            }
        };
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialContent() {
        return {
            autoFetchSiteTags: true,
            doNotShrink: false,
            forceShrink: false,
            size: AdBanner_contracts_1.AdBannerSize.MainIndex,
            sizes: [],
            type: AdBanner_contracts_1.AdBannerType.Default
        };
    }
    /**
     * Options for the `<DashmixSelect name="size">`.
     */
    get sizeOptions() {
        return Object.values(AdBanner_contracts_1.AdBannerSize).map(value => ({
            label: `${this.$t('forms.adBanner.' + value)}`,
            value
        }));
    }
};
AdBannerModuleForm = AdBannerModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({ name: 'AdBannerModuleForm' })
], AdBannerModuleForm);
exports.AdBannerModuleForm = AdBannerModuleForm;
//# sourceMappingURL=AdBanner.form.js.map